export default __webpack_public_path__ + "static/media/icons_indicators_flags_albanian.eea7bf5c.png";